import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { DaySettingForQueueDto } from '../models/dtos/config/day-setting-for-queue-dto';
import { DialogService } from 'primeng/dynamicdialog';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import html2pdf from 'html2pdf.js';
import * as XLSX from 'xlsx';
import { StorageUtil } from '../utils/storage.util';

@Injectable()
export class BirthdayService {

    constructor(private http: HttpClient,
                private dialog: DialogService,
    ) {}

    buildPDF() {
        const element = document.getElementById('birthdaysTable');
        const opt = {
            margin:      0,
            filename:     'birthdayReport.pdf',
            image:        { type: 'jpeg', quality: 0.98 },
            html2canvas:  { scale: 2, logging: true, useCORS: true },
            jsPDF:        { 
              unit: 'in', 
              format: 'a4', 
              orientation: 'landscape',
              compress: true
            }
          };
    
        html2pdf()
          .from(element)
          .set(opt)
          .save();
    }

    findWithFilter(filter:any):Observable<any>{
        if(undefined != filter.age){
            return this.findAgeFilter(filter);
        }
        if(undefined != filter.daysForBirthday){
            filter.startDate = undefined;
            filter.endDate = undefined;
        }
        return this.callBirthdayEndpoint(filter);
    }

    findAgeFilter(filter:any): Observable<any>{
        const birthday = new Date();
        const currentDate = new Date();
        birthday.setFullYear(currentDate.getFullYear() - filter.age);
        filter.endDate = birthday.toISOString();
        
        const startDate = new Date();
        startDate.setFullYear(birthday.getFullYear() - 1);
        filter.startDate = startDate.toISOString();
            
        return this.callBirthdayEndpoint(filter);
    }

    callBirthdayEndpoint(filter:any):Observable<any>{

        return this.http
            .post(environment.apiHost + '/api-core/secure/reports/birthday',filter)
            .pipe(map((response: any) => response));
    }

    newCallBirthdayEndpoint(filter:any):Observable<any>{

        return this.http
            .post(environment.apiHost + '/api-core/secure/reports/birth-day',filter)
            .pipe(map((response: any) => response));
    }

    exportToExcel(data: any[], filename: string, sheetName: string): void {
        if (!data || data.length === 0) {
            console.warn('Nenhum dado para exportar');
            return;
        }
        
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
        const workbook: XLSX.WorkBook = { 
            Sheets: { [sheetName]: worksheet }, 
            SheetNames: [sheetName] 
        };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveExcelFile(excelBuffer, filename);
    }

    private saveExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = fileName + '.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
    }

    buildPDFFromTable(tableId: string, filename: string): void {
        const element = document.getElementById(tableId);
        if (!element) {
            console.error('Elemento da tabela não encontrado:', tableId);
            return;
        }

        const opt = {
            margin: 0.5,
            filename: filename + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, logging: false, useCORS: true },
            jsPDF: {
                unit: 'in',
                format: 'a4',
                orientation: 'landscape',
                compress: true
            }
        };

        html2pdf()
            .from(element)
            .set(opt)
            .save();
    }

    exportToPDFWithData(data: any[], columns: any[], filename: string, title: string): void {
        if (!data || data.length === 0) {
            console.warn('Nenhum dado para exportar');
            return;
        }

        const marina = StorageUtil.getMarina();
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'px',
            floatPrecision: 2,
        });

        const dateNow = new Date().toLocaleString('pt-BR');
        const totalRecords = data.length;

        const horizontalCenter = doc.internal.pageSize.getWidth() / 2;
        const pixelsPerLetter = 6.5;
        const titleHorizontalAdjustment = (title.length / 2) * pixelsPerLetter;
        const titleX = horizontalCenter - titleHorizontalAdjustment;

        const marinaNameAdjustment = (marina.tradeName.length / 2) * pixelsPerLetter;
        const marinaNameX = horizontalCenter - marinaNameAdjustment;

        const tableData = data.map(item => columns.map(col => item[col.field] || ''));
        const tableHeaders = [columns.map(col => col.header)];

        (doc as any).autoTable({
            head: tableHeaders,
            body: tableData,
            bodyStyles: { halign: 'center', fontSize: 8 },
            headStyles: { halign: 'center', fillColor: '#495057', fontSize: 9 },
            theme: 'striped',
            margin: { top: 90 },
            didDrawPage: function (data) {
                const pageSize = doc.internal.pageSize;
                const pageHeight = pageSize.height || pageSize.getHeight();
                const pageWidth = pageSize.width || pageSize.getWidth();

                doc.setFontSize(16);
                doc.setTextColor(40);
                doc.text(marina.tradeName, marinaNameX, 65);
                doc.setFontSize(10);
                doc.text(dateNow, pageWidth - 100, 85);
                doc.setFontSize(20);
                doc.setTextColor('#495057');
                doc.text(title, titleX, 85);

                doc.setFontSize(10);
                doc.setTextColor(100);
                const pageNumber = (doc as any).internal.getNumberOfPages();
                doc.text(`Pág. ${pageNumber}`, pageWidth - 70, pageHeight - 32);
                doc.text(
                    `Total de registros: ${totalRecords}`,
                    data.settings.margin.left,
                    pageHeight - 32
                );
                doc.text(
                    'Desenvolvido por Easymarine',
                    data.settings.margin.left,
                    pageHeight - 12
                );
            },
        });

        doc.save(filename + '.pdf');
    }
    
}